import React, { PropTypes } from 'react';
import Gallery from 'react-grid-gallery';
import RemoveFile from './removeFile';
import FileName from './fileName';

const ImagePreview = props => {
  const {
    src,
    thumbnail,
    thumbnailWidth,
    thumbnailHeight,
    removeFile,
    fileName,
    showFileName,
    openGallery,
    showGallery,
    onlyOneImage,
  } = props;

  return (
    <div style={{ overflow: 'hidden', display: 'inline-block', width: onlyOneImage ? '475px' : '200px', height: '100%', position: 'relative' }}>
      <div onTouchTap={showGallery && openGallery}>
        <Gallery
          images={[{
            src,
            thumbnail,
            thumbnailWidth,
            thumbnailHeight,
          }]}
          enableImageSelection={false}
          rowHeight={onlyOneImage ? 300 : 120}
          backdropClosesModal
          enableLightbox={false}
          thumbnailStyle={() => ({ cursor: showGallery ? 'pointer' : 'default', width: '100%', height: null, marginLeft: 0 })}
        />
        {showFileName && <FileName fileName={fileName} />}
      </div>
      {removeFile && <RemoveFile removeFile={() => removeFile(src)} />}
    </div>
  );
};

ImagePreview.propTypes = {
  thumbnailWidth: PropTypes.number,
  thumbnailHeight: PropTypes.number,
  src: PropTypes.string,
  removeFile: PropTypes.func,
  thumbnail: PropTypes.string,
  fileName: PropTypes.string,
  showFileName: PropTypes.bool,
  openGallery: PropTypes.func,
  showGallery: PropTypes.bool,
  onlyOneImage: PropTypes.bool,
};

export default ImagePreview;



// WEBPACK FOOTER //
// ./src/app/components/extra/filePreview/imagePreview.jsx